// extracted by mini-css-extract-plugin
export default {"menuOpen":"Options_menuOpen__-hu56","optionDisabled":"Options_optionDisabled__+SzTi"};